module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "center"
  }, [_c('a', {
    attrs: {
      "id": "piv"
    }
  }), _vm._v(" Copyright © 1980 by Rupert Pole as trustee under the Last Will and Testament of Anaïs Nin"), _c('br'), _vm._v("\nPreface copyright © 1980 by Gunther Stuhlmann")]), _vm._v(" "), _c('p', {
    staticClass: "timebreak"
  }, [_c('br')]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_vm._v("All rights reserved.")]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_vm._v("No part of this publication may be reproduced or transmitted in any form or by any means, electronic or mechanical, including photocopy, recording, or any information storage and retrieval system, without permission in writing from the publisher.")]), _vm._v(" "), _c('p', {
    staticClass: "timebreak"
  }, [_c('br')]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_vm._v("For information about permission to reproduce selections from this book, write to Permissions, Houghton Mifflin Harcourt Publishing Company, 215 Park Avenue South, New York, New York 10003.")]), _vm._v(" "), _c('p', {
    staticClass: "timebreak"
  }, [_c('br')]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('a', {
    attrs: {
      "href": "http://www.hmhco.com/popular-reading",
      "target": "_blank"
    }
  }, [_vm._v("www.hmhco.com")])]), _vm._v(" "), _c('p', {
    staticClass: "timebreak"
  }, [_c('br')]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_vm._v("The editor and publisher wish to thank the C. G. Jung Foundation for permission to quote from "), _c('em', [_vm._v("Woman’s Mysteries")]), _vm._v(", by M. E. Harding, copyright 1971 by the C. G. Jung Foundation for Analytical Psychology; and William Morrow & Company, Inc. for permission to quote from "), _c('em', [_vm._v("Venture to the Interior")]), _vm._v(", by Laurens van der Post, copyright © 1951, 1979 by Laurens van der Post. The “Magic Circle Weekend” material ("), _c('span', {
    attrs: {
      "href": "#/c26#p212",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("[>]")]), _vm._v(") was first published by Magic Circle Press in "), _c('em', [_vm._v("Celebration with Anaïs Nin")]), _vm._v(", edited by Valerie Harms, copyright © 1973 by Valerie Harms.")]), _vm._v(" "), _c('p', {
    staticClass: "timebreak"
  }, [_c('br')]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_vm._v("The Library of Congress has cataloged the print edition as follows:"), _c('br'), _vm._v("\nNin, Anaïs, 1903–1977."), _c('br'), _vm._v("\nThe diary of Anaïs Nin."), _c('br'), _vm._v("\nVol. 3 has imprint:"), _c('br'), _vm._v("\nNew York, Harcourt, Brace &"), _c('br'), _vm._v("\nWorld; v. 4–7: New York, Harcourt Brace Jovanovich."), _c('br'), _vm._v(" "), _c('span', {
    staticStyle: {
      "font-size": "smaller"
    }
  }, [_vm._v("CONTENTS:")]), _vm._v(" v. 1. 1931–1934.—v. 2. 1934–1939.—v. 3. 1939–1944.—[etc.]—v. 7. 1966–1974."), _c('br'), _vm._v("\n1. Nin, Anaïs, 1903–77—Diaries. 2. Authors, American—20th century—Biography. I. Stuhlmann, Gunther, ed. II. Title.")]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('span', {
    staticStyle: {
      "font-size": "smaller"
    }
  }, [_vm._v("PS")]), _vm._v("3527."), _c('span', {
    staticStyle: {
      "font-size": "smaller"
    }
  }, [_vm._v("I")]), _vm._v("865"), _c('span', {
    staticStyle: {
      "font-size": "smaller"
    }
  }, [_vm._v("Z")]), _vm._v("5 818'.5203 [B] 66-12917"), _c('br'), _vm._v(" "), _c('span', {
    staticStyle: {
      "font-size": "smaller"
    }
  }, [_vm._v("ISBN")]), _vm._v(" 0-15-125596-2")]), _vm._v(" "), _c('p', {
    staticClass: "timebreak"
  }, [_c('br')]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_vm._v("e"), _c('span', {
    staticStyle: {
      "font-size": "smaller"
    }
  }, [_vm._v("ISBN")]), _vm._v(" 978-0-544-47780-3"), _c('br'), _vm._v("\nv1.1114")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-133015e8","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/front01.vue
// module id = 60
// module chunks = 0